'use strict';

var module = angular.module('app');

module.controller('TrackingController', function (
    $rootScope,
    $scope,
    $q,
    Shipments,
    $filter,
    $route,
    shipmentSelectsConsts,
    trackingStatusesConst,
    shipmentStatuses,
    toastr,
    $location,
    TrackingEventsService,
    $routeParams,
    $uibModal,
    ConfirmationModalFactory
) {
    var markerLabels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    $scope.vm = {};
    $scope.search = '';
    $scope.selectedShipment = false;
    $scope.inSearch = false;
    $scope.inLoadShipment = false;
    $scope.toTracking = false;
    $scope.trackingTableData = {};
    $scope.shipmentStatuses = shipmentStatuses;
    $scope.updateTrackingStatusToDelivered = updateTrackingStatusToDelivered;
    $scope.markAsDeliveredFirstMile = markAsDeliveredFirstMile;
    $scope.markAsDeliveredLastMile = markAsDeliveredLastMile



    var params = $route.current.params || {};
    var shipment = params.id || false;
    var oldButton = false;
    var showedShipment = false;
    var map, markers = [];
    var shipmentsTable = null;

    const updateTrackingStatusConf = new ConfirmationModalFactory({}, {
        message: 'messages.warning.tracking.MESSAGE',
        code: 'messages.warning.tracking.CODE'
    });

    function trackingStatuses() {
        $scope.trackingStatuses =
            [
                {
                    label: 'Documentation Prepared',
                    value: 'documentationprepared'
                }, {
                    label: 'Booking Arranged',
                    value: 'bookingarranged'
                }, {
                    label: 'Pickup Complete',
                    value: 'collected'
                }, {
                    label: 'In Transit',
                    value: 'intransit'
                }, {
                    label: 'Arrived at Destination',
                    value: 'arrivedatdestination'
                }, {
                    label: 'Out for Delivery',
                    value: 'outfordelivery'
                }, {
                    label: 'Attempted Delivery',
                    value: 'attemped_delivery'
                }, {
                    label: 'Awaiting Collection',
                    value: 'awaiting_collection'
                }, {
                    label: 'Delivered',
                    value: 'delivered'
                }
            ];

        $scope.trackingError =
            [
                {
                    label: 'Cancelled',
                    value: 'cancelled'
                }, {
                    label: 'Missing',
                    value: 'missing'
                }, {
                    label: 'Customs held',
                    value: 'customs_held'
                }, {
                    label: 'Damaged',
                    value: 'damaged'
                },
                {
                    label: 'Return to Sender',
                    value: 'return_to_sender'
                }
            ];
    }

    if (shipment) {
        Shipments.getShipmentDetails(shipment, function (ship) {
            if (ship.code) {
                $scope.noContent = true;
            } else {
                $scope.sentSearchTracking(ship.trackingNumber);
                trackingStatus(ship)
                showTracking(ship);
                //setBackButtonOpt(ship); 
            }
        });
    }

    var showTracking = function (data, button) {
        trackingStatuses();
        if (showedShipment && (showedShipment == data.id)) return;
        showedShipment = data.id;
        if (button) {
            button = angular.element(button.currentTarget);
            if (oldButton) {
                oldButton.removeClass('no-active');
            }
            oldButton = button.addClass('no-active');
        }
        $scope.inLoadShipment = true;
        Shipments.getTracking(data.id, function (tracking) {
            $scope.trackingEventsData = new TrackingEventsService('', tracking.trackingEvents).data;
            $scope.selectedShipment = angular.extend(data, { tracking: tracking });

            if (data.appliedShippingRule.carrierId === 'bba-driver-direct') {
                getTrackingLocation(data).then(function (coordinate) {
                    $scope.selectedShipment.packageCoordinate = coordinate;
                });
            }


            $scope.toTracking = !$scope.toTracking;
            $scope.activeStatusIndex = 0;

            $scope.trackingStatus = trackingStatusesConst.trackingStatuses[$scope.selectedShipment.trackingStatus]
                ? trackingStatusesConst.trackingStatuses[$scope.selectedShipment.trackingStatus] :
                $scope.selectedShipment.trackingStatus;
            $scope.bookingStatus = $scope.shipmentStatuses[$scope.selectedShipment.bookingStatus]
                ? $scope.shipmentStatuses[$scope.selectedShipment.bookingStatus] :
                $scope.selectedShipment.bookingStatus;

            const trackingError = $scope.trackingError.find(tracking => tracking.value == $scope.selectedShipment.trackingStatus);
            if (trackingError) {
                if (trackingError.value === 'return_to_sender') {
                    $scope.trackingStatuses[8] = trackingError;
                } else {
                    $scope.trackingStatuses[4] = trackingError;
                }

            }

            if($scope.trackingStatus === 'on_forwarded'){
                $scope.trackingStatuses.splice(5, 0, { label: formatStatus($scope.trackingStatus), value: $scope.trackingStatus });
                $scope.trackingStatuses[5].isActive =true;
                $scope.activeStatusIndex = 5;
                        
            }else{
                const trackingStatus = $scope.trackingStatuses.findIndex(tracking=> tracking.value == $scope.selectedShipment.trackingStatus);
                $scope.trackingStatuses[trackingStatus].isActive = true;
                $scope.activeStatusIndex = trackingStatus;
            }

            

            $scope.inLoadShipment = false;
        }, function () {
            $scope.inLoadShipment = false;
            $scope.noContent = true;
        });


    };

    function formatStatus(status) {
        return status
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase());
    }

    if (shipment) {
        Shipments.getItem(shipment, function (ship) {
            if (ship.code) {
                $scope.noContent = true;
            } else {
                $scope.sentSearchTracking(ship.trackingNumber);
                showTracking(ship);
                //setBackButtonOpt(ship);
            }
        });
    }

    function addMarker(location, map, index, opts) {
        markers.push(new google.maps.Marker(angular.extend({
            position: location,
            label: index ? markerLabels[index] : '',
            map: map
        }, opts)));
    }

    function trackingStatus(ship) {
        $scope.trackingStatusText = trackingStatusesConst.trackingStatuses[ship.trackingStatus]
            ? trackingStatusesConst.trackingStatuses[ship.trackingStatus] :
            ship.trackingStatus;

        const trackingStatus = $scope.trackingStatuses.find(item => item.value === ship.trackingStatus);
        if (!trackingStatus) {
            if ($scope.trackingStatus !== 'return_to_sender') {
                $scope.widthChange = true;
                $scope.trackingStatuses.splice(4, 0, { text: $scope.trackingStatusText, value: $scope.trackingStatus })
                $scope.activeStatusIndex = 4;
            }

        } else {
            $scope.widthChange = false;
        }

    }

    function zoomToMarkers(map, markers) {
        let bounds = new google.maps.LatLngBounds();
        let points = markers;
        for (let n = 0; n < points.length; n++) {
            bounds.extend(points[n].position);
        }
        map.fitBounds(bounds);
    }

    function updateTrackingStatusToDelivered() {

        showMarkAsDeliveredModal();
    }

    function showMarkAsDeliveredModal() {
        const modal = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: 'full-height-modal',
            templateUrl: '/templates/pages/shipments/update-tracking-status-modal.html',
            controller: 'TrackingStatusModalController',
            controllerAs: 'vm',
            size: 'sm',
            appendTo: $('body')
        });

        modal.result.then(date => {
            if (!date) { return; }
            updateTrackingStatus(date);
        });
    }

    function markAsDeliveredFirstMile() {
        updateMileTrackingStatus('first_mile')
    }

    function markAsDeliveredLastMile() {
        updateMileTrackingStatus('last_mile')
    }

    function updateMileTrackingStatus(miles) {
        $scope.updatingTrackingStatus = false;

        Shipments.updateMilesTrackingStatus($scope.selectedShipment.id,
            miles,
            res => {
                $scope.updatingTrackingStatus = false;
                $scope.sentSearchTracking($scope.search)
                toastr.success('Shipment tracking status has been successfully updated to DELIVERED', 'Success!');
            },
            err => {
                $scope.updatingTrackingStatus = false;
            }
        )
    }

    function updateTrackingStatus(date) {
        $scope.updatingTrackingStatus = true;

        const momentDate = moment(date);
        const isoDateString = momentDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ');

        Shipments.updateTrackingStatus($scope.selectedShipment.id, {
            deliveredDate: isoDateString
        }, data => {
            $scope.updatingTrackingStatus = false;
            $scope.selectedShipment.trackingStatus = 'delivered';
            toastr.success('Shipment tracking status has been successfully updated to DELIVERED', 'Success!');
        }, error => {
            $scope.updatingTrackingStatus = false;
            toastr.error(error.message, 'Error');
        });
    }

    $scope.initMap = function () {
        map = new google.maps.Map(document.getElementById('map-container'), {
            mapTypeId: 'terrain'
        });
        var lineSymbol = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };
        var path = [];

        //List of Coordinates
        if ($scope.selectedShipment.tracking.trackingEvents) {
            $scope.selectedShipment.tracking.trackingEvents.map(function (item, index) {
                if (angular.getObjVal(item, 'locationDetails.lat') && angular.getObjVal(item, 'locationDetails.lng')) {
                    path.push(item.locationDetails);
                    addMarker(item.locationDetails, map, index);
                }
            });
        }

        if ($scope.selectedShipment.packageCoordinate) {
            addMarker($scope.selectedShipment.packageCoordinate, map, null, {
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 7
                }
            })
        }

        //Draw line on the Map
        var polyOptions = {
            strokeColor: '#0070cf',
            strokeOpacity: 0.8,
            strokeWeight: 5,
            geodesic: false,
            path: path
        };
        var poly = new google.maps.Polyline(polyOptions);
        poly.setMap(map);

        //Calculate Center/Zoom of Polyline
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < path.length; i++) {
            bounds.extend(path[i]);
        }
        //map.fitBounds(bounds);
        zoomToMarkers(map, markers);
    };

    $scope.sentSearchTracking = function (search) {
        $scope.search = search;
        if (!$scope.search || !$scope.search.length) return;

        $scope.selectedShipment = false;
        $scope.inSearch = true;
        showedShipment = false;
        oldButton = false;
        $scope.noContent = false;
        Shipments.search(data => {
            $scope.inSearch = false;
            $scope.startSearch = data.content.length > 1;
            if (data.content.length >= 1) {
                showTracking(data.content[0]);
            } else if (!$scope.startSearch) {
                // toastr.warning('Please try again', 'No results found');
                $scope.noContent = true;
            }
        }, err => {

        }, { item: $scope.search });
    };

    $scope.$on('setGlobalFilter', function (event, officeFilter) {
        if (officeFilter != undefined) {
            shipmentsTable.updateTableData({}, {});
        }
    });

    $scope.goTo = function () {
        if ($scope.selectedShipment.bookingStatus.toLowerCase() === 'processed') {
            $location.path('/reporting/view/' + $scope.selectedShipment.id).search({ 'prev': 'tracking' });
        } else {
            $location.path('/orders/details/' + $scope.selectedShipment.id).search({ 'prev': 'tracking' });
        }
    };

    function getTrackingLocation(shipment) {
        var defer = $q.defer();

        Shipments.getTrackingLocation(shipment.trackingNumber, function (coordinate) {
            defer.resolve(coordinate);
        }, function (error) {
            defer.resolve(null);
        });

        return defer.promise;
    }

    $scope.$on('$routeChangeStart', function (event, next, current) {
        if (next.$$route.originalPath !== '/orders/details/:id' && next.$$route.originalPath !== '/reporting/view/:shipmentId') {
            localStorage.removeItem('page');
        }
    });
});


// WEBPACK FOOTER //
// ./js/controllers/shipment/TrackingController.js